import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TemplateLibraryModal = ({ isOpen, onClose }) => {
  const [templateName, setTemplateName] = useState('');
  const [colorScheme, setColorScheme] = useState('#2563EB');
  const [paymentTerms, setPaymentTerms] = useState('30');
  const [legalText, setLegalText] = useState('');

  if (!isOpen) return null;

  const handleSave = () => {
    console.log('Saving template:', { templateName, colorScheme, paymentTerms, legalText });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-3xl bg-card rounded-xl elevation-2xl overflow-hidden border border-border max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-heading font-semibold text-foreground flex items-center gap-2">
              <Icon name="Layout" size={24} className="text-primary" />
              Create Invoice Template
            </h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-muted rounded-md transition-smooth"
              aria-label="Close modal"
            >
              <Icon name="X" size={20} className="text-muted-foreground" />
            </button>
          </div>

          <div className="space-y-6">
            {/* Template Name */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Template Name *
              </label>
              <input
                type="text"
                value={templateName}
                onChange={(e) => setTemplateName(e?.target?.value)}
                placeholder="e.g., Professional Blue"
                className="w-full px-4 py-2 bg-background border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary/50"
              />
            </div>

            {/* Logo Upload */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Company Logo
              </label>
              <div className="border-2 border-dashed border-border rounded-lg p-6 text-center hover:border-primary transition-smooth cursor-pointer">
                <Icon name="Upload" size={32} className="text-muted-foreground mx-auto mb-2" />
                <p className="text-sm text-foreground mb-1">Click to upload or drag and drop</p>
                <p className="text-xs text-muted-foreground">PNG, JPG up to 2MB</p>
              </div>
            </div>

            {/* Color Scheme */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Color Scheme
              </label>
              <div className="flex items-center gap-4">
                <input
                  type="color"
                  value={colorScheme}
                  onChange={(e) => setColorScheme(e?.target?.value)}
                  className="w-16 h-10 rounded border border-border cursor-pointer"
                />
                <input
                  type="text"
                  value={colorScheme}
                  onChange={(e) => setColorScheme(e?.target?.value)}
                  className="flex-1 px-4 py-2 bg-background border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary/50"
                />
              </div>
            </div>

            {/* Payment Terms */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Payment Terms (Days)
              </label>
              <select
                value={paymentTerms}
                onChange={(e) => setPaymentTerms(e?.target?.value)}
                className="w-full px-4 py-2 bg-background border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary/50"
              >
                <option value="15">Net 15</option>
                <option value="30">Net 30</option>
                <option value="45">Net 45</option>
                <option value="60">Net 60</option>
              </select>
            </div>

            {/* Legal Text */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Legal Text / Terms
              </label>
              <textarea
                value={legalText}
                onChange={(e) => setLegalText(e?.target?.value)}
                rows={4}
                placeholder="Enter legal text, terms and conditions..."
                className="w-full px-4 py-2 bg-background border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 resize-none"
              />
            </div>

            {/* Preview Section */}
            <div className="bg-background border border-border rounded-lg p-6">
              <h3 className="text-sm font-semibold text-foreground mb-4 flex items-center gap-2">
                <Icon name="Eye" size={18} className="text-primary" />
                Preview
              </h3>
              <div className="aspect-[4/3] bg-muted/30 rounded-lg flex items-center justify-center">
                <Icon name="FileText" size={64} className="text-muted-foreground" style={{ color: colorScheme }} />
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-3 mt-6">
            <Button
              variant="outline"
              size="lg"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
            <Button
              variant="default"
              size="lg"
              onClick={handleSave}
              iconName="Save"
              iconPosition="left"
              fullWidth
            >
              Save Template
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateLibraryModal;